import { useRef, useState } from 'react';
import { useClickAway } from 'react-use';
import { Manual } from '../../../api/model';
import useContextMenu from '../../../hooks/useContextMenu';
import { ManualComment } from './ManualComment';
import { ManualDelete } from './ManualDelete';
import { ManualDownload } from './ManualDownload';

type Props = {
  manual: Manual;
  onSearch: () => void;
};

function ManualRow({ manual, onSearch }: Props) {
  const { points, setPoints } = useContextMenu();
  const [contextOpen, setContextOpen] = useState(false);

  const ref = useRef(null);
  useClickAway(ref, () => {
    setContextOpen(false);
  });

  const handleContextMenu = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e.preventDefault();
    setContextOpen(true);
  };

  return (
    <tr>
      <td>
        <span className="manualpopfr">
          <span
            className="grayfr"
            onContextMenu={(event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
              event.preventDefault();
              setPoints({ x: event.pageX, y: event.pageY });
              handleContextMenu(event);
            }}
          >
            {manual.file_name}
          </span>
          <ul
            className="pop"
            style={{
              display: contextOpen ? 'block' : '',
              position: 'fixed',
              top: `${points.y}px`,
              left: `${points.x}px`,
            }}
            ref={ref}
          >
            {manual.manual_id && <ManualDownload manualId={manual.manual_id} />}
            {manual.manual_id && <ManualDelete manualId={manual.manual_id} onSearch={onSearch} />}
          </ul>
        </span>
      </td>
      <td>{manual.updated_at}</td>
      <td>{manual.update_user_name}</td>
      <td>
        <ManualComment manual={manual} onSearch={onSearch} />
      </td>
    </tr>
  );
}

export { ManualRow };
